"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", theme.color.dark.silver, ";background-color:", theme.color.dark.mars, ";")
  );
};

var header =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;flex-flow:row nowrap;cursor:pointer;padding:16px 16px;");
var title =
/*#__PURE__*/
(0, _emotion.css)("flex:1;font-size:16px;letter-spacing:0px;text-transform:capitalize;");

var toggleIcon = function toggleIcon() {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:relative;")
  );
};

var toggleHorizontal = function toggleHorizontal(theme, expanded) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;background-color:", theme.color.dark.sapphire, ";width:14px;height:2px;left:50%;margin-left:-14px;top:50%;margin-top:-1.5px;transition:all 0.2s ease-in-out;transform:rotate(-90deg);opacity:1;border-radius:1px;", expanded && "\n    transition: all 0.2s ease-in-out;\n    transform: rotate(90deg);\n    opacity: 0;\n  ")
  );
};

var toggleVertical = function toggleVertical(theme, expanded) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;background-color:", theme.color.dark.sapphire, ";width:2px;height:14px;left:50%;margin-left:-8px;top:50%;margin-top:-7.5px;transition:all 0.2s ease-in-out;transform:rotate(-90deg);border-radius:1px;", expanded && "\n    transition: all 0.2s ease-in-out;\n    transform: rotate(90deg);\n  ")
  );
};

var selectedItem =
/*#__PURE__*/
(0, _emotion.css)("display:inline-block;");
var selectedItems =
/*#__PURE__*/
(0, _emotion.css)("padding:0 16px;margin-bottom:6px;> *{margin-bottom:8px;}> *:not(:last-child){margin-right:8px;}");

var items = function items(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("padding:16px 20px;color:", theme.color.dark.iron, ";background-color:", theme.color.dark.saturn, ";margin-top:2px;/* margin-bottom:14px;*/\n  max-height:150px;overflow-y:auto;")
  );
};

var _default = {
  root: root,
  header: header,
  title: title,
  toggleIcon: toggleIcon,
  toggleHorizontal: toggleHorizontal,
  toggleVertical: toggleVertical,
  selectedItem: selectedItem,
  selectedItems: selectedItems,
  items: items
};
exports.default = _default;